/*global _ */
import {fv} from '../../../../lib/utils'
import InputMixin from '../../../../mixins/form/input-options'
import DesignerMixin from './designer'
const mixins = [InputMixin, DesignerMixin]

export default {
  name: 're-checkboxes',
  mixins,
  props: {
    value: {
      type:[Array, Object, String, Boolean, Number],
      default: null
    },
    inputClass: {
      type: String,
      default: 'form-control-checkboxes'
    },
    inputElementClass: {
      type: [String, Array, Object],
      default: ''
    },
    inputElementAttrs: {
      type: [String, Array, Object],
      default() {
        return {}
      }
    },
    mainLabelClass: {
      type: [String, Array, Object],
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      innerValue: _.isObject(this.value) ? _.values(this.value) : _.castArray(fv(this.value, [])),
    }
  },
  methods: {
    reduceOptionItem(data) {
      data.checked = (this.innerValue || []).includes(data.value)
      return data
    },
    getInputProps(item, key, isComponent) {
      const selected = item.checked
      const mapValue = (values) => {
        if (_.isArray(values)) {
          return _.map(values, mapValue)
        }
        if (_.isObject(values)) {
          return _.mapValues(values, i => {
            if (_.isObject(i)) {
              return mapValue(i)
            }
            if (i === '$item') {
              return {key: key, ..._.cloneDeep(item), selected}
            }
            return i
          })
        }
        return values
      }
      const attrs = _.merge(
        {},
        mapValue(this.inputComponentAttrs || {}),
        selected ? mapValue(this.inputSelectedComponentAttrs || {}) : {}
      )
      if (isComponent) {
        attrs.context = this.context || this.$parent
      }
      return {
        showErrors: false,
        multi: true,
        name: this.name,
        tabindex: this.tabindex,
        id: item.id || null,
        label: item.label,
        labelClass: item.labelClass || this.labelClass,
        inputElementClass: this.inputElementClass,
        inputElementAttrs: this.inputElementAttrs,
        ...attrs
      }
    },
    onInput(value, item) {
      this.isDirtyState = true
      const values = _.values(_.map(_.pickBy(this.optionsList, i => i.checked), o => o.value))
      this.model = values
    },
    getLabelExtraClasses() {
      return ['re-input-label-checkboxes', this.mainLabelClass]
    }
  }
}
